module.exports = __webpack_public_path__ + "fonts/Pretendard-Regular.c5817dc1.woff";